import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpService } from "../service/http-service";
import { Location } from "@angular/common";
import { CommonService } from "../service/common";
import { API } from "../config/api-config";

@Component({
  selector: "app-goal-params-edit",
  templateUrl: "./goal-params-edit.component.html",
  styleUrls: ["./goal-params-edit.component.css"],
})
export class GoalParamsEditComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private HttpService: HttpService,
    private location: Location,
    private common: CommonService
  ) {}

  private id: number = 0;

  public isCreate: boolean = false;

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.id = params["id"];
      this.data.id = this.id;
    });
    if (this.id != 0) {
      this.getData();
    } else {
      this.isCreate = true;
    }
  }

  public data: any = {
    active: 1,
    titleEn: "",
    titleTc: "",
    id: 0,
  };

  private getData() {
    this.HttpService.getData(API.goalParameter + "/" + this.id).then((res) => {
      this.data = res.data;
    });
  }

  public submit() {
    let data = this.data;
    delete data.createdBy;
    delete data.createdTime;
    delete data.updatedBy;
    delete data.updatedTime;
    this.HttpService.postData(API.goalParameter, data).then((res) => {
      let data = res;
      if (data.status.code == 0 || data.status.code == "0") {
        this.location.back();
      } else {
        alert(data.status.message);
      }
    });
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/goal-params-edit/goal-params-edit.component.ts